//Timespan constants
export const GRACEPERIOD = 1;
